<script lang="ts">
  import { onMount } from "svelte"
  import Recognition from "$app/Pages/Plans/Recognitions/Recognition.svelte"
  import TopRecognized from "$app/Pages/Plans/Recognitions/TopRecognized.svelte"
  import TopGivers from "$app/Pages/Plans/Recognitions/TopGivers.svelte"
  import awardsSVG from "@images/recognitions/awards.svg"
  import { appStore } from "$app/store.svelte"

  let { dates, top_recognitions, recognition_stats } = $props()

  export function valid(): boolean {
    return true
  }

  const brandPurpose = appStore.statements.find(
    (st) => st.section_type === "BrandPurpose"
  )
  const blueSkyVision = appStore.statements.find(
    (st) => st.section_type === "BlueSkyVision"
  )
  const values = appStore.statements
    .filter((st) => st.section_type === "CoreValue")
    .slice(0, 5)

  onMount(async () => {
    appStore.recognitions = top_recognitions
  })
</script>

<div class="max-w-4xl mx-auto pt-8">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="max-w-4xl mx-auto text-center">
      <h2 class="text-2xl lg:text-3xl font-bold text-black">
        Building Our Culture and Practicing Gratefulness
      </h2>
      <img src={awardsSVG} class="mx-auto w-80 my-3" alt="Recognition Stats" />
      <p class="mt-3 text-xl lg:text-2xl text-gray-500 sm:mt-4">
        Here are your teams stats for {dates.prev_quarter}
      </p>
    </div>
  </div>
  <div class="mt-8 pb-8">
    <div class="relative">
      <div class="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="max-w-4xl mx-auto">
          <dl class="rounded-sm bg-white shadow-sm sm:grid sm:grid-cols-4">
            <div
              class="flex flex-col border-b border-gray-100 p-6 text-center sm:border-0 sm:border-r"
            >
              <dt
                class="order-2 mt-2 text-lg leading-6 font-medium text-gray-500"
              >
                Recognitions Received
              </dt>
              <dd class="order-1 text-5xl font-extrabold text-indigo-700">
                {recognition_stats.total_recipients}
              </dd>
            </div>
            <div
              class="flex flex-col border-b border-gray-100 p-6 text-center sm:border-0 sm:border-r"
            >
              <dt
                class="order-2 mt-2 text-lg leading-6 font-medium text-gray-500"
              >
                Recognitions<br /> Sent
              </dt>
              <dd class="order-1 text-5xl font-extrabold text-indigo-700">
                {recognition_stats.total_sent}
              </dd>
            </div>
            <div
              class="flex flex-col border-t border-b border-gray-100 p-6 text-center sm:border-0 sm:border-l sm:border-r"
            >
              <dt
                class="order-2 mt-2 text-lg leading-6 font-medium text-gray-500"
              >
                Likes on Recognitions
              </dt>
              <dd class="order-1 text-5xl font-extrabold text-indigo-700">
                {recognition_stats.total_likes}
              </dd>
            </div>
            <div
              class="flex flex-col border-t border-gray-100 p-6 text-center sm:border-0 sm:border-l"
            >
              <dt
                class="order-2 mt-2 text-lg leading-6 font-medium text-gray-500"
              >
                Comments on Recognitions
              </dt>
              <dd class="order-1 text-5xl font-extrabold text-indigo-700">
                {recognition_stats.total_comments}
              </dd>
            </div>
          </dl>
        </div>
      </div>

      <div class="mt-4 relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          class="max-w-4xl mx-auto flex justify-center bg-white shadow-sm flex-wrap"
        >
          <div
            class="border border-gray-100 shadow-sm rounded-sm bg-white p-2 w-1/2 lg:w-2/12"
          >
            <div class="h-36">
              <div class="text-sm font-bold text-center">Brand Purpose</div>
              <img
                src={brandPurpose.symbol_url}
                class="w-12 h-12 rounded-full mx-auto mt-4"
                alt={brandPurpose.name}
              />
              <div class="text-sm text-center mt-4">
                {brandPurpose.name}
              </div>
            </div>
            <div class="text-xs text-center mt-3 mb-1">
              <span
                class="py-1 px-2 rounded-sm border border-indigo-600 text-indigo-500 font-semibold whitespace-nowrap"
              >
                {recognition_stats.total_brand_purpose} SENT
              </span>
            </div>
          </div>
          <div
            class="border border-gray-100 shadow-sm rounded-sm bg-white p-2 w-1/2 lg:w-2/12"
          >
            <div class="h-36">
              <div class="text-sm font-bold text-center">Blue Sky Vision</div>
              <img
                src={blueSkyVision.symbol_url}
                class="w-12 h-12 rounded-full mx-auto mt-4"
                alt={blueSkyVision.name}
              />
              <div class="text-sm text-center mt-4">
                {blueSkyVision.name}
              </div>
            </div>
            <div class="text-xs text-center mt-3 mb-1">
              <span
                class="py-1 px-2 rounded-sm border border-indigo-600 text-indigo-500 font-semibold whitespace-nowrap"
              >
                {recognition_stats.total_bsv} SENT
              </span>
            </div>
          </div>

          <div
            class="border border-gray-100 shadow-sm rounded-sm bg-white p-2 w-full lg:w-8/12"
          >
            <div class="text-sm font-bold text-center">Values</div>
            <div class="flex justify-around">
              {#each values as value}
                <div class="mx-2">
                  <div class="h-26">
                    <img
                      src={value.symbol_url}
                      class="w-12 h-12 rounded-full mx-auto mt-4"
                      alt={value.name}
                    />
                    <div class="text-sm text-center mt-4">
                      {value.name}
                    </div>
                  </div>
                  <div class="text-xs text-center mt-4 mb-1">
                    <span
                      class="py-1 px-2 rounded-sm border border-indigo-600 text-indigo-500 font-semibold whitespace-nowrap"
                    >
                      {recognition_stats.total_values.find(
                        (v) => v.value_id === value.id
                      )?.count || 0} SENT
                    </span>
                  </div>
                </div>
              {/each}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="grid grid-cols-2 gap-6">
        <TopRecognized
          show_all={false}
          top_recognized={recognition_stats.top_recognized}
        />

        <TopGivers show_all={false} top_givers={recognition_stats.top_givers} />
      </div>
    </div>
  </div>
</div>

<h2 class="text-2xl text-center w-full py-6 font-semibold">Top Recognitions</h2>

<div class="max-w-4xl mx-auto sm:px-6 lg:px-8 pb-8">
  <ul class="gap-y-4 w-full">
    {#each appStore.recognitions as recognition}
      <Recognition {recognition} readOnly={true} />
    {:else}
      <div
        class="bg-red-50 py-4 px-8 border border-gray-200 shadow-lg text-lg text-center"
      >
        No Recognitions Were Sent During Quarter
      </div>
    {/each}
  </ul>
</div>
